import { Badge } from '@radix-ui/themes';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useMemo } from 'react';

export const CommonPriorityBadge = (props: {
  priority: BuildPriority | undefined;
}) => {
  const label = useMemo(() => {
    switch (props.priority) {
      case BuildPriority.Breaks: {
        return 'BRK';
      }

      default: {
        return 'SPN';
      }
    }
  }, [props.priority]);

  return <Badge color={RADIX.COLOR.NEUTRAL}>{label}</Badge>;
};
